module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-35.a726145d.png";